export default {
  setMessages(state, payload) {
    state.messages = payload
  },
  updateMessages(state, payload) {
    state.messages = state.messages.concat(payload)
  },
  setSmsHistoryFilters(state, payload) {
    state.smsHistoryFilters = payload
  },
  setSmsHistoryStatuses(state, payload) {
    state.smsStatuses = payload
  },
  sortMessagesByDate(state) {
    const sortMessage = (a, b) => {
      if (a.created_at > b.created_at) return -1
      if (a.created_at < b.created_at) return 1
    }
    state.messages.sort(sortMessage)
  },
}
